<template>
 <div style="width:90%">
		<div class="container_body">
      <header class="header_nav">
        <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="用户ID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
          <el-form-item label="用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
          <el-form-item label="用户级别" class='tiny' cleartable>
            <el-select clearable  v-model="searchInfo.userLevel" placeholder="请选择级别"
						style="width:150px;">
							<el-option v-for="item in serLevelList" :key="item.value" :label="item.name"
							:value="item.value"></el-option>
						</el-select>
					</el-form-item>
            <el-form-item label="月份" class='tiny' cleartable>
              <el-date-picker
                v-model="monthData"
                value-format="yyyy-MM"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <template>
                <el-button type="primary" @click="searchData">查询</el-button>
                <el-button  @click="empty">清空</el-button>
              </template>
            </el-form-item>
        </el-form>
      </header>
    </div>
    <el-table :data="performanceData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
    element-loading-spinner="el-icon-loading" :header-cell-style="headClass">
        <el-table-column property="userId" fixed label="用户ID" width="100" align="center"></el-table-column>
        <el-table-column property="username" fixed label="用户名" width="150" align="center"></el-table-column>
        <el-table-column property="userLevel" label="用户级别" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.userLevel == '0'">会员</span>
            <span v-if="scope.row.userLevel == '1'">小超</span>
            <span v-if="scope.row.userLevel == '2'">经理</span>
            <span v-if="scope.row.userLevel == '3'">县代</span>
            <span v-if="scope.row.userLevel == '4'">区代</span>
            <span v-if="scope.row.userLevel == '5'">市代</span>
            <span v-if="scope.row.userLevel == '6'">省代</span>
            <span v-if="scope.row.userLevel == '7'">运营中心</span>

          </template>
        </el-table-column>
        <el-table-column property="statisticsMonth" label="月份" align="center"></el-table-column>
        <el-table-column property="shopStrength" label="月采购(￥)" align="center"></el-table-column>
        <el-table-column property="shopShareStrength" label="月分享(￥)" align="center"></el-table-column>
        <el-table-column property="createTime" label="创建时间" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column property="updateTime" label="更新时间" :show-overflow-tooltip="true" align="center"></el-table-column>
      </el-table>
      <el-pagination  background :current-page="page.pageNum"
      @current-change="pageChangeRecords" layout="total, sizes, prev, pager, next, jumper" :total="performanceTotal"
      @size-change="handleSizeChangeRecords" :page-sizes="[10, 20, 50, 100]">
      </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      performanceData:[],
      page: {
					pageNum: 1,
					pageSize: 10
			},
      loading: false,
      performanceTotal: 0,
      searchInfo: {},
      monthData:[],
      serLevelList:[
        {
          value: '0',
          name: '会员'
        },
        {
          value: '1',
          name: '经理'
        },
        {
          value: '2',
          name: '县代'
        },
        {
          value: '3',
          name: '区代'
        },
        {
          value: '4',
          name: '市代'
        },
        {
          value: '5',
          name: '省代'
        },
        {
          value: '6',
          name: '运营中心'
        },
      ],
    }
  },
  methods: {
    pageChangeRecords(val) {
      this.page.pageNum = val
      this.getPerformanceList()
    },
    handleSizeChangeRecords(val) {
      this.page.pageSize = val
      this.getPerformanceList()
    },
    headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
		},
    searchData() {
      if(this.monthData.length>0){
        this.searchInfo.startTime = this.monthData[0]
        this.searchInfo.endTime = this.monthData[1]
      }
      console.log(this.searchInfo)
      this.getPerformanceList(this.searchInfo)
    },
    empty() {
      this.searchInfo = {}
    },
    getPerformanceList(obj) {
      this.loading = true;
      let data = Object.assign(this.page, obj)
      this.$api.getAgentMonthList(data).then(res => {
        console.log(res)
        console.log("-----------------------------------")
        if(res.state === 'success'){
          this.performanceData = res.data.list
          this.performanceTotal = res.data.total
          this.loading = false
        }else {
          this.performanceData = []
          this.performanceTotal = 0
          this.loading = false
        }
      })
    },
  },
  created() {
    this.getPerformanceList()
  },
}
</script>